import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { mergeRefs } from '@react-aria/utils';
import React from 'react';
import { Header } from 'react-aria-components';

var _excluded = ["ref"];

// This is a separate component so that headingProps.id doesn't override the item key in useCachedChildren.
function SectionHeader(_ref) {
  var item = _ref.item,
    headingProps = _ref.headingProps,
    headingRef = _ref.headingRef;
  var _item$props = item.props,
    ref = _item$props.ref,
    otherProps = _objectWithoutProperties(_item$props, _excluded);
  return /*#__PURE__*/React.createElement(Header, _extends({}, headingProps, otherProps, {
    ref: mergeRefs(headingRef, ref)
  }), item.rendered);
}

export { SectionHeader as default };
//# sourceMappingURL=section-header.esm.js.map
